import React from "react";
import { StylesConfig } from "react-select";
/**
 * @type {StylesConfig}
 */
const SikkaSelectTheme = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: isFocused ? "#0b1727" : "#0b1727",
    color: "#fff",
    borderColor: "#0b1727",
  }),
  option: (styles, { data, isDisabled, isSelected, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? "#232e3c" : isSelected ? "#2c7be5" : isFocused ? "#2a3441" : "#232e3c",
      borderColor: "#232e3c",
    };
  },
  input: (styles) => ({ ...styles, color: "#fff" }),
  singleValue: (styles, { data }) => {
    return {
      ...styles,
      color: "#fff",
    };
  },
  menu: (styles) => ({
    ...styles,
    backgroundColor: "#232e3c",
    border: "1px solid #344050",
    boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.35)",
    zIndex: 10001,
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 10001,
  }),
  menuList: (styles) => ({
    ...styles,
    backgroundColor: "#232e3c",
    "::-webkit-scrollbar": {
      width: "9px",
    },
    "::-webkit-scrollbar-track": {
      background: "#0b1727",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  }),
  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "#232e3c",
      color: "#fff",
    };
  },
  multiValueLabel: (styles, { data }) => {
    return {
      ...styles,
      color: "#fff",
    };
  },
};

export default SikkaSelectTheme;
